/**
 * Insere funcionalidades adicionais nos objetos Button
 *
 * @author Wellington
 * @since 2020-01-04
 * @version 1.0.1
 * @license Comercial
 */

const htmlButtonElementExtensions = {

  /**
   * Desabilita o botão
   * 
   * @returns HTMLBUttonElement
   */
  disable() {
    this.disabled = true;
    this.classList.add('disabled');
    return this; // Permite encadeamento
  },

  /**
   * Habilita o botão
   * 
   * @returns HTMLBUttonElement
   */
  enable() {
    this.disabled = false;
    this.classList.remove('disabled');
    return this; // Permite encadeamento
  },
};


const extendHTMLButtonElement = () => {
  Object.entries(htmlButtonElementExtensions).forEach(([key, value]) => {
    if (!HTMLButtonElement.prototype[key]) {
      HTMLButtonElement.prototype[key] = value;
    } else {
      console.warn(`HTMLButtonElement.prototype.${key} já existe e não será sobrescrito.`);
    }
  });
};

export default extendHTMLButtonElement;
